export const VERSION_ASSET_FILE = 'version.json'
export const VERSION_ASSET_PATH = `/${VERSION_ASSET_FILE}`
